import React from 'react';

const reduceExtrusions = (verticals, qty) =>
  Object.values(
    verticals.reduce((acc, { extrusions = [] }) => {
      extrusions.forEach(({ type, desc, lengths = [] }) => {
        lengths.forEach((length) => {
          const key = [type, desc, length].join('_');

          acc[key] = acc[key] || {
            type,
            desc,
            length,
            qty: 0,
          };
          acc[key].qty += qty;
        });
      });

      return acc;
    }, {})
  ).sort((left, right) => {
    if (left.type !== right.type) return left.type.localeCompare(right.type);
    if (left.desc !== right.desc) return left.desc.localeCompare(right.desc);
    return left.length - right.length;
  });

export default ({ system: { verticals, qty } }) => {
  const extrusions = reduceExtrusions(verticals, qty);

  if (extrusions.length === 0) return null;

  return (
    <table
      className="table table-bordered table-sm cut-list"
      style={{ fontSize: 12 }}
    >
      <thead>
        <tr>
          <th>Extrusion</th>
          <th>Length</th>
          <th>Qty</th>
          <th>Desc</th>
        </tr>
      </thead>
      <tbody>
        {extrusions.map(({ type, length, qty: totalQty, desc }) => (
          <tr key={`${type}-${desc}-${length}`}>
            <td>{type}</td>
            <td>{length}"</td>
            <td>{totalQty}</td>
            <td>{desc}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
